import { Configuration as msalConfiguration } from "@azure/msal-browser";

const isProduction = import.meta.env.MODE === "production";

// Get some values from .env file
let {
  VITE_MSAL_REDIRECT_URL,
  VITE_MSAL_CLIENT_ID,
  VITE_MSAL_AUTHORITY,
  VITE_GOOGLE_MAPS_API_KEY,
} = import.meta.env;

// If development, use localhost
if (!isProduction) VITE_MSAL_REDIRECT_URL = "http://localhost:3001/home";

export const msal: msalConfiguration = {
  auth: {
    clientId: VITE_MSAL_CLIENT_ID ?? "",
    authority: VITE_MSAL_AUTHORITY,
    redirectUri: VITE_MSAL_REDIRECT_URL,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// App-level config
export const api = {
  googleMapsApiKey: VITE_GOOGLE_MAPS_API_KEY,
};

// S2 API config
export const api_s2 = {
  baseURL:
    import.meta.env.MODE != "development"
      ? "https://papi.pymblelc.nsw.edu.au/"
      : "http://localhost:8000/",
  scopes: ["api://pymble-apis/access"],
};

// App configuration
export const app = {
  notifyCoverTeachers: true, // TODO: Set to true after testing
  defaultNoticeImg:
    "https://pymblelc.blob.core.windows.net/assets/banners/REN_7254.jpg",
  defaultGroupIcon:
    "https://pymblelc.blob.core.windows.net/assets/pymble-p.png",
  colorPrimary: "#002f67",
  approvalLockPeriod: 3,
  attendanceExcemptionForm: {
    url: "https://pymblelc.blob.core.windows.net/assets/forms/Application-for-Exemption-from-Attendance-Form.pdf",
    title: "Application for Exemption from Attendance",
    text: "Leave Form",
  },
  privacyPolicyUrl:
    "https://www.pymblelc.nsw.edu.au/wp-content/uploads/2021/02/Privacy-Policy.pdf",
  securityPolicyUrl:
    "https://www.pymblelc.nsw.edu.au/wp-content/uploads/2021/02/Security-Policy.pdf",
  pymbleHandbookUrl:
    "https://www.pymblelc.nsw.edu.au/mypymble/?toKnowledgeBase=true",
  userGuideUrl:
    "https://sites.google.com/pymblelc.nsw.edu.au/parent-portal-2021/",
};
